var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { parseContent } from '@ally/ally-md-parser';
import whisper from './whisper';
var useMboxCall = function (mboxName, defaultValue, parse) {
    if (parse === void 0) { parse = false; }
    var _a, _b, _c;
    var adobe = window.adobe;
    var _d = React.useState(null), data = _d[0], setData = _d[1];
    React.useEffect(function () {
        function callMbox() {
            return __awaiter(this, void 0, void 0, function () {
                var startTime;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            startTime = Date.now();
                            return [4 /*yield*/, adobe.target.getOffer({
                                    mbox: mboxName,
                                    success: function (successData) {
                                        var endTime = Date.now();
                                        window.allytm.event('customEvent', {
                                            type: 'offerTiming',
                                            name: 'aosTargetTiming',
                                            attr: {
                                                mbox: mboxName,
                                                timeToLoadDecision: endTime - startTime,
                                                timeToLoadContent: 0,
                                                totalTime: endTime - startTime,
                                            },
                                        });
                                        return setData(successData);
                                    },
                                    error: function (status, error) {
                                        whisper.error({
                                            message: ['target.getOffer failure in useMboxCall', error, status],
                                        });
                                    },
                                })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (!adobe)
            setData(defaultValue);
        else
            callMbox();
    }, [adobe]);
    if (parse) {
        // Because we can't expect adobe to always return content and template, set some defaults to be safe
        // default value will be {content, template} or {} from mbox component
        var defaults = Object.keys(defaultValue).length > 0
            ? defaultValue
            : { content: null, template: null };
        // Currently, json offers that follow the prescribed Mbox format should have action: 'setJson'
        var mboxObject = Array.isArray(data)
            ? data.find(function (mbox) {
                return mbox.action === 'setJson';
            })
            : null;
        var _e = (_c = (_b = (_a = mboxObject) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b[0], (_c !== null && _c !== void 0 ? _c : defaults)), content = _e.content, template = _e.template, color = _e.color, muiIconName = _e.muiIconName;
        var cleanContent = void 0;
        if (content) {
            cleanContent = parseContent(content);
        }
        else if (defaults.content)
            cleanContent = parseContent(defaults.content);
        else {
            cleanContent = defaults.content;
        }
        return { mboxData: { content: cleanContent, template: template, color: color, muiIconName: muiIconName } };
    }
    return { mboxData: data };
};
export default useMboxCall;
//# sourceMappingURL=index.js.map